export const NAVIGATION_CHANNEL_NAME = `console_navigation_channel_${window.location.origin}`;
export const TAB_ID_KEY = 'console_tab_id';

// Broadcast message types
export const MESSAGE_TYPES = {
    CLAIM_WINDOW: 'CLAIM_WINDOW',
    NAVIGATE_TO_URL: 'NAVIGATE_TO_URL',
} as const;
